/**
 * ResNweb
 */
const factory = function factory({ window, document, thn }) {
    const hotelId = window.basedir;
    return {
        getId() {
            return '325';
        },
        check() {
            return !!hotelId;
        },
        getSiteId() {
            return {
                externalId: hotelId,
            };
        },
    };
};

export { factory };
